import { RectangleItem } from '@mcp-artwork/cimdoc-types-v2'
import { v4 as uuidv4 } from 'uuid'
import { DesignSurface } from '@mcp-artwork/cimdoc-types-v2/dist/DesignSurface'
import { ImageWithDimensions } from '../image'
import { DesignView } from './targetSpecifications/types'
import { getBleedArea, getSafeArea } from './targetSpecifications/client'
import { getGrayscaleMatrix, Tone } from '../imageEffects'

const MAIN_PANEL_SCALE_FACTOR = 0.8

export const generateMainPanel = (
  panel: DesignView,
  logo: ImageWithDimensions,
  backgroundColor: string,
  panelId: string,
  tone: Tone,
): DesignSurface => {
  const shapeId = uuidv4()
  const imageId = uuidv4()
  const fullBleed = getBleedArea(panel)
  const safeArea = getSafeArea(panel)

  // Use safeArea dimensions if available, otherwise default to fullBleed
  let panelWidth = fullBleed.position.width
  let panelHeight = fullBleed.position.height

  // Apply scale factor to panel dimensions
  const scaledPanelWidth = panelWidth * MAIN_PANEL_SCALE_FACTOR - safeArea.position.x * 2
  const scaledPanelHeight = panelHeight * MAIN_PANEL_SCALE_FACTOR - safeArea.position.y * 2

  // Calculate image dimensions while maintaining aspect ratio
  const imageAspectRatio = logo.width / logo.height
  const panelAspectRatio = scaledPanelWidth / scaledPanelHeight
  let imageWidthCm: number
  let imageHeightCm: number

  if (imageAspectRatio > panelAspectRatio) {
    imageWidthCm = scaledPanelWidth
    imageHeightCm = imageWidthCm / imageAspectRatio
  } else {
    imageHeightCm = scaledPanelHeight
    imageWidthCm = imageHeightCm * imageAspectRatio
  }

  // Calculate positions to center the image within the panel
  const xPosition = (panelWidth - imageWidthCm) / 2
  const yPosition = (panelHeight - imageHeightCm) / 2

  return {
    id: `${panelId}`,
    decorationTechnology: panel.processType || 'inkJet',
    name: panel.name || 'Front',
    width: `${panelWidth}cm`,
    height: `${panelHeight}cm`,
    colorMode: 'color',
    shapes: [
      {
        id: `${shapeId}`,
        zIndex: 1,
        type: 'rectangle',
        position: {
          x: `0cm`,
          y: `0cm`,
          width: `${panelWidth}cm`,
          height: `${panelHeight}cm`,
        },
        color: backgroundColor !== 'transparent' ? `rgb(${backgroundColor})` : `rgba(0,0,0,0)`,
      } as RectangleItem,
    ],
    images: [
      {
        id: `${imageId}`,
        zIndex: 2,
        pageNumber: 1,
        previewUrl: logo.url,
        printUrl: logo.url,
        position: {
          x: `${xPosition}cm`,
          y: `${yPosition}cm`,
          width: `${imageWidthCm}cm`,
          height: `${imageHeightCm}cm`,
        },
        rotationAngle: '0',
        effects: tone !== 'original' ? [getGrayscaleMatrix(tone)] : [],
      },
    ],
  }
}
